module.exports = __webpack_public_path__ + "static/media/img2-4.d5eb2fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img2-4.png
// module id = 1528
// module chunks = 3